var hessenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Hessen?',
    image: '361',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Hessen?',
    answers: [
      {
        content: 'Ammerland',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Prignitz',
        key: 0,
      },
      {
        content: 'Main-Taunus-Kreis',
        key: 1,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Hessen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Hessen bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Hessen?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'rot-weiß',
        key: 1,
      },
      {
        content: 'schwarz-gold',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Hessen über politische Themen informieren?',
    answers: [
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Hessen heißt...',
    answers: [
      {
        content: 'Kassel.',
        key: 0,
      },
      {
        content: 'Darmstadt.',
        key: 0,
      },
      {
        content: 'Frankfurt.',
        key: 0,
      },
      {
        content: 'Wiesbaden.',
        key: 1,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Hessen?',
    image: '368',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Hessen?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Hessen',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Hessen nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Hessen',
  },
]

export default hessenQuestions
